/**
 * Account (package) Permissions Configuration
 * Raw permission names as stored in the DB `package_permission_list` table.
 * Use these constants instead of literal strings when checking account permissions.
 */

export const ACCOUNT_PERMISSIONS = {
    AI_AGENT: 'ai agent',
    AREA: 'area',
    BILLING: 'billing',
    BOXOFFICE: 'boxoffice',
    CANCELLATION_FEE: 'cancellation fee',
    CLUSTER: 'cluster',
    CONSUMER_CLUBS: 'consumer clubs',
    COUPON_VOUCHER: 'coupon voucher',
    COURSE: 'course',
    CREDIT_REFUND: 'credit refund',
    CRM_IMPORT: 'crm import',
    CROWDS: 'crowds',
    CURRENCY: 'currency',
    CUSTOM_PIXEL: 'custom pixel',
    CUSTOMER_CONFIRMATION: 'customer confirmation',
    DEFAULT_USER_CANCEL_TICKET: 'default user cancel ticket',
    DEFAULT_WHATSAPP: 'default whatsApp',
    DESIGN: 'design',
    DOMAIN: 'domain',
    EVENT_CASH: 'event cash',
    EXTERNAL_VOUCHER: 'external voucher',
    FIELDS: 'fields',
    FORM_EDIT: 'form edit',
    GIVECHAK: 'givechak',
    GLATTICKET_SHOW: 'glatticket show',
    GOOGLE_WALLET_TICKET: 'google wallet ticket',
    GROUP_COUPON: 'group_coupon',
    HOME: 'home',
    HUB: 'hub',
    LANGUAGE: 'language',
    LANGUAGE_ADVANCED: 'language advanced',
    LISTING: 'listing',
    MAIN_HUB: 'main hub',
    PACKAGE_CASH: 'package cash',
    PACKAGE_CRM: 'package crm',
    PACKAGE_PACKAGE: 'package package',
    PAYMENTS: 'payments',
    PROMOTION_MESSAGE: 'promotion message',
    PUBLISH: 'publish',
    PUBLISH_EMBED: 'publish embed',
    PUBLISH_PIXEL: 'publish pixel',
    RESERVED: 'reserved',
    SCHEDULED: 'scheduled',
    SMS_ENTER: 'sms enter',
    SUBSCRIPTION: 'subscription',
    SUSPENDED: 'suspended',
    TICKET: 'ticket',
    TICKET_VALIDITY: 'ticket validity',
    TICKETS_BRANDING: 'tickets branding',
    TICKETS_EMAIL: 'tickets email',
    TICKETS_LIVE: 'tickets live',
    TIMETABLE: 'timetable',
    UNDATED_EVENT: 'undated event',
    USER_CANCEL_TICKET: 'user cancel ticket',
    WHATSAPP: 'whatsApp',
    WHATSAPP_SUPPORT: 'whatsApp support',
} as const;

// Type for TypeScript autocomplete and type safety
export type AccountPermission = typeof ACCOUNT_PERMISSIONS[keyof typeof ACCOUNT_PERMISSIONS];
